import React from 'react'
import { Link } from "react-router-dom"
import { useLocation } from 'react-router-dom';

export default function NavbarLine(props) {
    const location = useLocation();

    const { pathname } = location;

    const splitLocation = pathname.split("/");

    const title = props.title
    const projectId = props.id
    const projNum = props.projNum

    console.log("test", splitLocation)


    return (
        <li className="dropdown-item" id={(splitLocation[2] == projectId ? "activeItem" : "")}>
            <Link className="nav-link text-dark" to={"/viewprojects/" + projectId} >{projNum} - {title}</Link>
        </li>
    )
}